import TableOfContents from './TableOfContents';

export default TableOfContents;
export * as TableOfContentsStyles from './TableOfContents.styles';
export * as TableOfContentsTypes from './TableOfContents.types';
